import React from "react";

const Button = ({ children, onClick, type = "button", disabled = false, loading = false, className = "" }) => {
  return (
    <button
      type={type}
      className={`${className} text-white text-sm bg-custom-orange hover:bg-custom-orange-200 py-2 px-3 rounded-[5px]`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? "Loading..." : children}
    </button>
  );
};
export default Button;
